import { useReviewRecordingReturn } from "./useReviewRecordingReturn";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import { Button } from "@/components/ui/Button";
import { errorMessage } from "@/lib/api";
import {
  isCurrentDraftContext,
  type DraftContext,
} from "@/features/coach-review/composerDrafts";
import { readReviewCarry } from "./reviewState";
import type { MatchSlot } from "@/features/matches/matchSlots";
export function ReviewRecordingReturn({
  owner,
  captureId,
  matchId,
  slot,
  video,
}: {
  owner: DraftContext | null;
  captureId: string;
  matchId: string;
  slot: MatchSlot;
  video: React.RefObject<HTMLVideoElement>;
}) {
  const navigate = useNavigate();
  const carry = owner ? readReviewCarry(owner) : null;
  const [error, setError] = useState("");
  const inFlight = useRef(false);
  const alive = useRef(true);
  useEffect(() => {
    alive.current = true;
    return () => {
      alive.current = false;
    };
  }, []);
  const mutation = useReviewRecordingReturn(
    owner,
    captureId,
    matchId,
    slot,
    video,
  );
  return (
    <section
      className="flex flex-wrap items-center gap-2 border-t border-rule p-3"
      aria-label="Inbox recording evidence"
    >
      <p className="text-sm">
        Choose the real recording and frame. Return to approve the same draft;
        no extra note or clip is created.
      </p>
      <Button
        disabled={!carry || !matchId || mutation.isPending}
        onClick={() => {
          if (inFlight.current) return;
          inFlight.current = true;
          setError("");
          void mutation
            .mutateAsync()
            .then(() => {
              if (alive.current && owner && isCurrentDraftContext(owner))
                void navigate({ to: "/coach", search: { tab: "board" } });
            })
            .catch((e) => {
              if (alive.current && owner && isCurrentDraftContext(owner))
                setError(errorMessage(e));
            })
            .finally(() => {
              inFlight.current = false;
            });
        }}
      >
        Use this recording and playhead
      </Button>
      <Button
        variant="outline"
        onClick={() =>
          void navigate({ to: "/coach", search: { tab: "board" } })
        }
      >
        Return without attaching
      </Button>
      {error && (
        <p role="alert" className="text-sm">
          {error}
        </p>
      )}
    </section>
  );
}
